import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApiErrorResponse } from '@bn/primitives';
import { AbstractApiService } from '@bn/shared/core/abstracts/abstract-api.service';

import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor extends AbstractApiService implements HttpInterceptor {
  private authService = inject(AuthService);

  constructor() {
    super();

    this.apiUrl = `${this.envConfig.apiUrl}/auth`;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse | ApiErrorResponse) => {
        // Note: logout user only in case we get 401 error on jwt-refresh call

        if ([401, 403, 500].includes(err.status) && request?.url === `${this.apiUrl}/jwt/refresh`) {
          // Note: Check if loggedIn again and logout in case not
          if (!this.authService.isLoggedIn() || err.status === 500) {
            this.authService.logout('Token expired or invalid.');
          }
        }

        return throwError(() => err);
      }),
    );
  }
}
